var styles = {"fontElementMap":"wCg5f","orderedlist":"_1NrKV","bulletedlist":"SQ97S","listItem":"ke--X"};

export { styles as s };
//# sourceMappingURL=lists-31154823.js.map
